var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quiz-answer-line",class:{
    'quiz-answer-line--potential': _vm.state === 'Potential',
    'quiz-answer-line--expected': _vm.state === 'Expected',
    'quiz-answer-line--correct': _vm.state === 'Correct',
    'quiz-answer-line--wrong': _vm.state === 'Wrong',
    'quiz-answer-line--not-selected': _vm.state === 'Not Selected',
  }},[_c('div',{staticClass:"quiz-answer-line__content"},[(_vm.showCheckmark)?_c('div',{staticClass:"quiz-answer-line__checkmark"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M20 6L9 17L4 12","stroke":"black","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e(),_c('div',{staticClass:"quiz-answer-line__text"},[_vm._v(_vm._s(_vm.question))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }